import { GridRenderCellParams } from "@mui/x-data-grid";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CompanyLogo } from "@/components/CompanyLogo";
import { DataRow } from "../types";

export const CompanyNameCell = (params: GridRenderCellParams<DataRow>) => {
  return (
    <Tooltip title={params.row.name || ""} placement="bottom">
      <Stack direction="row" alignItems="center" gap={1} overflow="hidden">
        <CompanyLogo domain={params.row.url} size={24} variant="rounded" />
        <Typography variant="body2" noWrap>
          {params.row.name}
        </Typography>
      </Stack>
    </Tooltip>
  );
};
